import { render } from "./Stocks.vue?vue&type=template&id=73e9a35c&scoped=true"
import script from "./Stocks.vue?vue&type=script&lang=js"
export * from "./Stocks.vue?vue&type=script&lang=js"

import "./Stocks.vue?vue&type=style&index=0&id=73e9a35c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e9a35c"]])

export default __exports__